function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.938 3.75H3.063A2.063 2.063 0 001 5.813v12.375c0 1.138.924 2.062 2.063 2.062h17.875A2.063 2.063 0 0023 18.187V5.813a2.063 2.063 0 00-2.063-2.062zM3.063 5.125h17.875a.69.69 0 01.687.688V7.59c-.941.795-2.286 1.891-6.471 5.212-.726.576-2.157 1.964-3.154 1.947-.997.017-2.432-1.37-3.154-1.947-4.185-3.321-5.53-4.417-6.471-5.212V5.812a.69.69 0 01.688-.687zm17.875 13.75H3.063a.69.69 0 01-.688-.688V9.38c.98.803 2.527 2.045 5.616 4.499.88.704 2.436 2.256 4.009 2.247 1.564.013 3.107-1.525 4.009-2.247 3.09-2.454 4.636-3.696 5.616-4.5v8.81a.69.69 0 01-.688.687z",
  fill: "#fff"
});
function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgMail;